import { ThemedMultiselectDropdown } from "@vega-core/components/Form/Controls/Dropdown/ThemedMultiselectDropdown/ThemedMultiselectDropdown";
import { type OptionType } from "@vega-core/models/options";

import {
  type FilterState,
  FilterType,
  type FilterValue,
  type MultiselectFilterConfig,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type Props = {
  filter: MultiselectFilterConfig;
  isLoading: boolean;
  filterState: FilterState;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
  disabled?: boolean;
};

export function MultiselectFilter({
  filter,
  isLoading,
  filterState,
  onFilterChange,
  showLabel,
  tableId,
  disabled = false,
}: Props) {
  // Use filter-level showLabel if specified, otherwise fall back to prop
  const shouldShowLabel = filter.showLabel ?? showLabel;

  return (
    <ThemedMultiselectDropdown
      {...filter.props}
      disabled={Boolean(filter.props.disabled || isLoading || disabled)}
      label={shouldShowLabel ? filter.label : undefined}
      name={`${tableId}-${filter.id}`}
      options={filter.props.options}
      selectedOptions={
        (getFilterValue(filterState, filter.id, FilterType.Multiselect) as
          | OptionType[]
          | undefined) ?? []
      }
      setSelectedOptions={(options: OptionType[]) =>
        onFilterChange(filter.id, options)
      }
    />
  );
}
